<template>
  <div class="batch-card-sort-combo">
    <p
      v-if="showHide"
      :id="'batch-card-sort-combo-container-' + index"
      class="label"
      @click="handleToggleVisibility(index)"
    >
      Lote ordenado por {{ labelSelected }}.
      <span>Clique</span>
      para reordenar
    </p>

    <div v-else>
      <md-layout
        md-flex="100"
        md-flex-medium="100"
      >
        <md-input-container>
          <advanced-select
            id="cboSortPrintBatch"
            v-model="selectedOption"
            placeholder="Selecione uma opção"
            direction="top"
            :options="options"
            name="sort"
            @onChange="handleChange"
          />
        </md-input-container>
      </md-layout>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import mixin from '@/components/PrintLabels/Batches/BatchesMixin'
import AdvancedSelect from '@/components/common/AdvancedSelect'

import strings from '@/strings'

export default {
  name: 'BatchCardSortCombo',
  components: {
    AdvancedSelect,
  },
  mixins: [mixin],
  props: {
    labelSelected: {
      type: String,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      showHide: true,
      lastSortPrintSelected: strings.sortPrintBatches[0],
      options: strings.sortPrintBatches,
      selectedOption:
        strings.sortPrintBatches.find(o => o.label === this.labelSelected) ||
        strings.sortPrintBatches[0],
    }
  },
  computed: {
    ...mapGetters(['unprintedBatches']),
  },
  watch: {
    labelSelected(newVal) {
      this.selectedOption =
        strings.sortPrintBatches.find(o => o.label === newVal) ||
        strings.sortPrintBatches[0]
    },
  },
  methods: {
    ...mapActions(['sortPrintBatchVisibility', 'sortPrintBatchSetColumn']),
    handleChange() {
      this.$emit('change', this.selectedOption)
      this.showHide = true
    },
    handleToggleVisibility() {
      this.showHide = !this.showHide
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.batch-card-sort-combo {
  display: flex;
  flex-direction: column;
  width: 100%;

  .label {
    margin-top: 8px;
    font-family: 'Exo 2', sans-serif !important;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    align-items: center;
    text-align: center;
    color: #828282;

    span {
      cursor: pointer;
      color: $theme-primary-color-darker;
      text-decoration: underline;
    }
  }

  .md-input-container {
    margin: 0;
    height: 40px;
    min-height: auto;
    padding-top: 8px;
  }
}
</style>
